export const BRAND = {
  name: "AMPLARTIC LOGISTICS INC.",
  short: "Amplartic Logistics",
  tagline: "Reliable Freight Solutions & Consolidation Services",
  blue: "#1E2A78",
  blueHover: "#17205E",
  yellow: "#FFD700",
  yellowHover: "#E6C200",
  logo: "https://customer-assets.emergentagent.com/job_shiptrack-global-4/artifacts/yb6k5nd1_Amplartic%20Logistic.png",
  phone: "1-877-213-2400",
  phoneHref: "tel:+18772132400",
  email: "shipping@amplarticlogistics.com",
  offices: [
    { city: "Maple Ridge", region: "BC", country: "Canada" },
    { city: "Mississauga", region: "ON", country: "Canada" },
    { city: "Miami", region: "FL", country: "USA" },
  ],
  destinations: [
    "Jamaica",
    "Trinidad & Tobago",
    "Barbados",
    "Guyana",
    "St. Lucia",
    "St. Vincent",
    "Grenada",
    "Dominica",
    "Antigua & Barbuda",
    "St. Kitts & Nevis",
    "Bahamas",
    "Belize",
  ],
};

export const SERVICE_TYPES = [
  "Sea Freight",
  "Air Freight",
  "Food Barrel Packing",
  "Door-to-Door",
  "Pre-Clearance",
  "Courier",
  "Sourcing",
  "Consolidation",
];

export const SHIPMENT_STATUSES = [
  "Pending Pickup",
  "Picked Up",
  "At Origin Warehouse",
  "In Transit",
  "Arrived at Destination Port",
  "Customs Clearance",
  "Out for Delivery",
  "Delivered",
];
